import apiClient from './client';

export const sitesApi = {
  getAll() {
    return apiClient.get('/sites');
  },

  getById(id) {
    return apiClient.get(`/sites/${id}`);
  },

  create(data) {
    return apiClient.post('/sites', data);
  },

  update(id, data) {
    return apiClient.put(`/sites/${id}`, data);
  },

  delete(id) {
    return apiClient.delete(`/sites/${id}`);
  },

  regenerateKey(id) {
    return apiClient.post(`/sites/${id}/regenerate-key`);
  },

  getTrackingCode(id) {
    return apiClient.get(`/sites/${id}/tracking-code`);
  },
};

export default sitesApi;
